import React from 'react';
import { PostHogProvider } from 'posthog-js/react';
import posthog from 'posthog-js';
import {
  bootstrapBookingPostHogAfterConsent,
  initBookingPostHog,
  isPostHogSupportedPlatform,
  optInBookingPostHog,
  optOutBookingPostHog,
} from '../analytics';
import { useConsent } from '../contexts/ConsentContext';

/**
 * Initialise PostHog uniquement après consentement analytics (aligné backoffice).
 */
const PostHogGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { consent } = useConsent();
  const [initialized, setInitialized] = React.useState(false);

  React.useEffect(() => {
    if (!isPostHogSupportedPlatform()) {
      optOutBookingPostHog();
      return;
    }

    if (consent === 'denied') {
      optOutBookingPostHog();
      return;
    }

    if (consent !== 'granted') return;

    const apiKey = process.env.REACT_APP_POSTHOG_KEY?.trim() || '';
    if (!apiKey) return;

    const bootstrap = () => {
      if (!initialized) {
        initBookingPostHog(apiKey);
        setInitialized(true);
      }
      optInBookingPostHog();
      bootstrapBookingPostHogAfterConsent();
    };

    if (typeof window.requestIdleCallback === 'function') {
      const idleId = window.requestIdleCallback(bootstrap, { timeout: 3500 });
      return () => window.cancelIdleCallback(idleId);
    }
    const timerId = window.setTimeout(bootstrap, 800);
    return () => window.clearTimeout(timerId);
  }, [consent, initialized]);

  if (consent === 'granted' && initialized) {
    return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
  }
  return <>{children}</>;
};

export default PostHogGate;
